export default __webpack_public_path__ + "static/media/vs.bf0b8acb.png";